module.exports = __webpack_public_path__ + "img/600.b2474653.svg";